import React, { Suspense }  from "react";
import "./App.css";
import {BrowserRouter, Route, Switch} from 'react-router-dom';
//import AdminRoutes from "./pages/Admin/AdminRoutes";
//import Routes from "./pages/Routes";
import {CurrencyBaseContext, CurrencyContext, ReservationContext, SearchContext} from './contexts/AppContext';
import {gStyles} from "./styles/globalStyles";
import {reservationDefaultValue, searchDefaultValue} from './utils/defaultNullValues';
import {UserAdminRoutes} from "./pages/UserAdmin/UserAdminRoutes";
import {UserProvider} from "./Hooks/UserHooks";
import {IReservation} from "./utils/ReservationInterfaces";
import { DohoneProvider } from "./Hooks/useDohone";
import { LoadingMenuProvider } from "./Hooks/LoadingMenuProvider";
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { BlogProvider } from "./Hooks/BlogProvider";
import { FooterProvider } from "./Hooks/FooterProvider";

const Routes = React.lazy(() => import("./pages/Routes"));
const AdminRoutes = React.lazy(() => import("./pages/Admin/AdminRoutes"));

const CLIENT_ID = "661752509570-k76eopsub8dsjmhrpatid4j0fbr8jho2.apps.googleusercontent.com";

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
}


// ErrorDisplay component that uses hooks
const ErrorDisplay = () => {
    const { t } = useTranslation();    
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            textAlign: 'center'
        }}>
            <div style={{
                maxWidth: '600px',
                padding: '30px',
                borderRadius: '8px',
                backgroundColor: 'white',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
                <h2 style={{ color: '#dc3545', marginBottom: '15px' }}>
                    {t('error_boundary.title')}
                </h2>
                <p style={{ fontSize: '18px', marginBottom: '25px', lineHeight: '1.6' }}>
                    {t('error_boundary.message')}
                </p>
                
                <button 
                    onClick={handleRefresh}
                    style={{
                        backgroundColor: '#890608',
                        color: 'white',
                        border: 'none',
                        padding: '12px 25px',
                        borderRadius: '4px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s',
                        marginBottom: '20px'
                    }}
                >
                    {t('error_boundary.action')}
                </button>
                
                {process.env.NODE_ENV === 'development' && (
                    <p style={{ fontSize: '14px', color: '#6c757d' }}>
                        {t('error_boundary.technical_info')}
                    </p>
                )}
            </div>
        </div>
    );
};

// ErrorBoundary component to catch errors
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { 
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({ 
            error,
            errorInfo,
            hasError: true 
        });
        console.error("Error caught by Error Boundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Render the translated error display
            return <ErrorDisplay />;
        }

        return this.props.children;
    }
}


function App() {
    gStyles()
    const [reservation, setReservation] = React.useState<IReservation>(reservationDefaultValue)
    const reservationValue = {reservation, setReservation}
    const [searchDta, setSearchData] = React.useState<any>(searchDefaultValue)
    const searchValue = {searchDta, setSearchData}
    const [currency, setCurrency] = React.useState<any>("XAF")
    const currencyValue = {currency, setCurrency}
    const [currencyBase, setCurrencyBase] = React.useState<any>("XAF")
    const currencyValueBase = {currencyBase, setCurrencyBase}
    const { t } = useTranslation();

    return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
    <HelmetProvider>
        <CurrencyBaseContext.Provider value={currencyValueBase}>
            <CurrencyContext.Provider value={currencyValue}>
                <DohoneProvider>
                    <UserProvider>
                        <SearchContext.Provider value={searchValue}>
                            <ReservationContext.Provider value={reservationValue}>
                                <LoadingMenuProvider>
                                    <FooterProvider>
                                    <BrowserRouter>
                                        <ErrorBoundary>
                                            <Suspense fallback={
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '100vh'
                                                }}>
                                                    {t('loading')}...
                                                </div>
                                            }>
                                                <BlogProvider>
                                                <Switch>
                                                    <Route path="/users/admin">
                                                        <UserAdminRoutes/>
                                                    </Route>
                                                    <Route path="/admin">
                                                    <AdminRoutes  />
                                                    </Route>
                                                    <Route path="/">
                                                        <Routes/>
                                                    </Route>
                                                </Switch>
                                                </BlogProvider>
                                            </Suspense>
                                        </ErrorBoundary>
                                    </BrowserRouter>
                                    </FooterProvider>
                                </LoadingMenuProvider>
                            </ReservationContext.Provider>
                        </SearchContext.Provider>
                    </UserProvider>
                </DohoneProvider>
            </CurrencyContext.Provider>
        </CurrencyBaseContext.Provider>
    </HelmetProvider>  
    </GoogleOAuthProvider>  
    );
}

export default App;
